import React, { useState } from 'react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'

const useAuth = () => {
    let user = localStorage.getItem('user_token');

    if (user) {
        try {
            if (user) {
                return user;
            }
        } catch (error) {
            return false
        }
    } else {
        return false
    }
}

const Auth = (props) => {
    const [collapsed, setCollapsed] = useState(true)
    const auth = useAuth()
    const navigate = useNavigate()
    const location = useLocation()

    // var permission = JSON.parse(localStorage.getItem('permission'))

    // const isRouteAuthorized = permission && permission.some(
    //     (item) => item.route === location.pathname
    // );

    // if (auth) {
    //     const action_id = permission?.find(
    //         (item) => item.route === location.pathname
    //     )

    //     localStorage.setItem('path', location.pathname)
    //     localStorage.setItem('action_id', action_id?.action_id)
    // }

    if (!auth) {
        return <Navigate to="/" />
    }
    // else if (!isRouteAuthorized) {
    //     // if (auth && isRouteAuthorized) {
    //     //     return <Navigate to="/dashboard" />
    //     // } else
    //     if (auth && location.pathname === '/') {
    //         return <Navigate to="/dashboard" />
    //     } else {
    //         Swal.fire({
    //             title: 'Access Denied',
    //             text: "You do not have permission to access this page. Please contact your Administrator to request access.",
    //             icon: 'error',
    //             showCancelButton: false,
    //             confirmButtonColor: '#121136',
    //             cancelButtonColor: '#EF3D50',
    //             confirmButtonText: 'Ok'
    //         }).then((result) => {
    //             if (result.isConfirmed) {
    //                 navigate(-1)
    //             }
    //         })
    //         return null;
    //     }
    // }
    else {
        return (
            <>
                <Outlet />
            </>
        )
    }
}

export default Auth;